<div class="overwrite-review" [class.is-collapsed]="collapsed" [style.width.px]="panelWidth">
  <!-- Left-edge resize handle (400–700px) -->
  <div
    class="overwrite-review__resize"
    title="Drag to resize (400–700px)"
    (mousedown)="startResize($event)"
  >
    <div class="overwrite-review__resize-dots">
      <span></span><span></span><span></span><span></span>
    </div>
  </div>

  <div class="overwrite-review__main">
    <!-- Header -->
    <div class="overwrite-review__header">
      <span class="overwrite-review__title">Overwrite Review</span>
      <button
        type="button"
        class="overwrite-review__collapse"
        [title]="collapsed ? 'Expand' : 'Minimize to header'"
        (click)="toggleCollapsed()"
      >
        <i class="fa-solid" [ngClass]="collapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
      </button>
    </div>

    <ng-container *ngIf="!collapsed">
      <!-- Pinned summary + bulk actions + Apply -->
      <div class="overwrite-review__bar">
        <div class="overwrite-review__summary">
          <span>Keep <b class="is-keep">{{ keepCount }}</b></span>
          <span class="overwrite-review__mid-dot">·</span>
          <span>Remove <b class="is-remove">{{ removeCount }}</b></span>
          <span class="overwrite-review__scope">
            {{ totalCount > 0
              ? "across " + worksheetsWithOverrides + " worksheet" + (worksheetsWithOverrides === 1 ? "" : "s")
              : "nothing pending" }}
          </span>
        </div>

        <div class="overwrite-review__actions">
          <button
            type="button"
            class="overwrite-review__bulk is-keep"
            [disabled]="isApplying || totalCount === 0"
            (click)="keepAll()"
          >
            <i class="fa-solid fa-check"></i> Keep all
          </button>
          <button
            type="button"
            class="overwrite-review__bulk is-remove"
            [disabled]="isApplying || totalCount === 0"
            (click)="rejectAll()"
          >
            <i class="fa-solid fa-xmark"></i> Reject all
          </button>
          <button
            type="button"
            class="overwrite-review__apply"
            [disabled]="isApplying || totalCount === 0"
            (click)="apply()"
          >
            <span *ngIf="!isApplying">Apply</span>
            <span *ngIf="isApplying">
              <i class="fa-solid fa-spinner overwrite-review__spin"></i> Applying
            </span>
          </button>
        </div>
      </div>

      <!-- Scroll region: worksheets + their overridden cells -->
      <div class="overwrite-review__body">
        <div class="overwrite-review__loading" *ngIf="isLoading">
          <i class="fa-solid fa-spinner overwrite-review__spin"></i> Loading overrides…
        </div>

        <!-- Empty -->
        <div class="overwrite-review__empty" *ngIf="!isLoading && totalCount === 0">
          <div class="overwrite-review__empty-icon"><i class="fa-solid fa-check"></i></div>
          <div class="overwrite-review__empty-title">No overrides to review</div>
          <div class="overwrite-review__empty-text">
            The re-import matched every cell. No manual overrides were affected, so there is nothing to keep or remove.
          </div>
        </div>

        <!-- Worksheet groups -->
        <ng-container *ngIf="!isLoading && totalCount > 0">
          <div class="overwrite-review__ws" *ngFor="let group of groups">
            <button
              type="button"
              class="overwrite-review__ws-header"
              [class.is-empty]="group.count === 0"
              [disabled]="group.count === 0"
              (click)="toggleGroup(group)"
            >
              <i class="fa-solid" [ngClass]="group.expanded ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
              <span class="overwrite-review__ws-name">{{ group.worksheetName }}</span>
              <span class="overwrite-review__ws-count" [class.is-active]="group.count > 0">{{ group.count }}</span>
            </button>

            <div class="overwrite-review__loading" *ngIf="group.expanded && group.loading">
              <i class="fa-solid fa-spinner overwrite-review__spin"></i> Loading…
            </div>

            <div class="overwrite-review__cells" *ngIf="group.expanded && group.loaded">
              <div
                class="overwrite-review__cell"
                *ngFor="let cell of group.cells; let i = index"
                [class.is-keep]="cell.action === 'keep'"
                [class.is-remove]="cell.action === 'remove'"
              >
                <span class="overwrite-review__cell-accent"></span>

                <div class="overwrite-review__cell-body">
                  <!-- Optional field line -->
                  <div class="overwrite-review__field" *ngIf="cell.fieldName">
                    <span class="overwrite-review__label">Field</span>
                    <span class="overwrite-review__field-val">{{ cell.fieldName }}</span>
                  </div>

                  <span class="overwrite-review__index">{{ i + 1 }}</span>

                  <div class="overwrite-review__data" (click)="navigateToCell(cell)">
                    <div class="overwrite-review__addr">
                      <div class="overwrite-review__label">Address</div>
                      <div class="overwrite-review__addr-line">
                        <span class="overwrite-review__addr-val">{{ cell.address }}</span>
                        <button
                          type="button"
                          class="overwrite-review__pen"
                          title="Edit address"
                          (click)="$event.stopPropagation(); startEdit(cell)"
                        >
                          <i class="fa-solid fa-pen"></i>
                        </button>
                      </div>
                    </div>
                    <div class="overwrite-review__value">
                      <div class="overwrite-review__label">Value</div>
                      <div class="overwrite-review__value-line">
                        <div class="overwrite-review__value-val" [title]="cell.value">{{ cell.value }}</div>
                        <button
                          type="button"
                          class="overwrite-review__view"
                          *ngIf="isLongValue(cell.value)"
                          title="View full value"
                          (click)="$event.stopPropagation(); openValue(cell)"
                        >
                          <i class="fa-solid fa-eye"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="overwrite-review__toggle">
                    <button
                      type="button"
                      class="overwrite-review__keep"
                      [class.is-active]="cell.action === 'keep'"
                      (click)="setAction(group, cell, 'keep')"
                    >
                      <i class="fa-solid fa-check" *ngIf="cell.action === 'keep'"></i> Keep
                    </button>
                    <button
                      type="button"
                      class="overwrite-review__remove"
                      [class.is-active]="cell.action === 'remove'"
                      (click)="setAction(group, cell, 'remove')"
                    >
                      <i class="fa-solid fa-xmark" *ngIf="cell.action === 'remove'"></i> Remove
                    </button>
                  </div>

                  <!-- Inline address editor -->
                  <div class="overwrite-review__editor" *ngIf="cell.editing" (click)="$event.stopPropagation()">
                    <div class="overwrite-review__editor-row">
                      <input
                        class="overwrite-review__input"
                        type="text"
                        [(ngModel)]="cell.addressDraft"
                        placeholder="B12"
                        [disabled]="cell.validating"
                        (keyup.enter)="confirmEdit(cell)"
                      />
                      <button type="button" class="overwrite-review__ed-btn is-accent" title="Use selected cell" [disabled]="cell.validating" (click)="useSelectedCell(cell)">
                        <i class="fa-solid fa-crosshairs"></i>
                      </button>
                      <button
                        type="button"
                        class="overwrite-review__ed-btn is-confirm"
                        [title]="cell.validating ? 'Checking the address…' : 'Confirm'"
                        [disabled]="cell.validating"
                        (click)="confirmEdit(cell)"
                      >
                        <i class="fa-solid" [ngClass]="cell.validating ? 'fa-spinner fa-spin' : 'fa-check'"></i>
                      </button>
                      <button type="button" class="overwrite-review__ed-btn" title="Cancel" (click)="cancelEdit(cell)">
                        <i class="fa-solid fa-xmark"></i>
                      </button>
                    </div>
                    <div class="overwrite-review__ed-error" *ngIf="cell.addressError">{{ cell.addressError }}</div>
                    <div class="overwrite-review__ed-help" *ngIf="!cell.addressError">
                      Type a cell reference or read the current grid selection.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>

  <ng-template #valueDialog>
    <div class="ow-value-dialog" *ngIf="viewingValue">
      <div class="ow-value-dialog__head">
        <span class="ow-value-dialog__title">Value — {{ viewingValue.worksheet }} · {{ viewingValue.address }}</span>
        <button type="button" class="ow-value-dialog__close" title="Close" (click)="closeValueDialog()">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="ow-value-dialog__body">{{ viewingValue.value }}</div>
    </div>
  </ng-template>
</div>
